module.exports = __webpack_public_path__ + "static/img/25.9be7d3d3.png";